<template>
<div>
  <div class="px-1 pt-1 pb-4" v-if="items.length > 0">
    <v-row no-gutters>
      <v-col :xs="5" :sm="5" :md="5" :lg="2" :xl="2" :cols="5" class="px-1">
        <span class="search-number">{{ rowNumber }}</span>件 の検索結果
      </v-col>
      <v-col :xs="7" :sm="7" :md="7" :lg="4" :xl="4" :cols="7">
        <dd-custom-button
          :loading="isCsvDownloader"
          :disabled="isCsvButtonDisabled"
          tooltipText="一覧をCSVファイル形式でダウンロードします"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg"
          @click="onCsvButtonClick">
          CSVで出力
          <template v-slot:loader>
            <span>出力中...</span>
          </template>
        </dd-custom-button>
        <a id="csvdownload" href="#" style="display:none;">ダウンロード</a>
      </v-col>
      <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="mt-2">
        <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
      </v-col>
      <v-col :xs="6" :sm="6" :md="3" :lg="3" :xl="3" :cols="6" class="px-1">
        <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
      </v-col>
    </v-row>

    <hr class="section-line mb-2">

    <v-row no-gutters>
      <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12">
        <v-row no-gutters>
            <div v-if="isBatchCommand">
              <v-row no-gutters>
                <v-col :cols="4" class="px-1">
                  <dd-drop-down
                    value="一括操作"
                    :items="['一括操作', '削除']"
                  />
                </v-col>
                <v-col :cols="2" class="mt-1">
                  <dd-custom-button
                    :rounded="true"
                    :minWidth="60"
                    :small="true"
                    @click="onDummyFunction"
                  >
                    適用
                  </dd-custom-button>
                </v-col>
              </v-row>
            </div>
        </v-row>
      </v-col>
      <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12">
        <dd-select-items-per-page
          ref="pagination1"
          :itemsPerPage.sync="vitemsPerPage"
          :currentPage.sync="vPage"
          :items="items"
          @changeItemsPerPage="changeItemsPerPage"
          @changePage="changePage"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col :cols="12" class="px-1">
        <v-data-table
          :item-key="itemKey"
          :headers="itemHeaders"
          :items="items"
          v-model="selected"
          :search="searchText"
          :custom-filter="filtering"
          :items-per-page="vitemsPerPage"
          :page.sync="vPage"
          @dblclick:row="onRowDoubleClick"
          no-data-text="対象データはありません"
          :show-select="isShowSelect"
          fixed-header
          hide-default-footer
          locale="ja-jp"
          dense
        >
          <template v-slot:[`item.actions`]="{item}">
            <template>
              <dd-icon-button-with-tooltip
                message="この行を編集します"
                icon="mdi-pencil-circle"
                @click="onRowEditButtonClick(item)"
              />
            </template>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <div v-else class="pb-2" />

  <div class="pa-2" v-if="items.length > 0">
    <v-row no-gutters>
      <v-col :xs="12" :sm="12" :md="2" :lg="2" :xl="2" :cols="12" class="px-1">
        <span class="search-number">{{ rowNumber }}</span>件 の検索結果
      </v-col>
      <v-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" :cols="12">
        <dd-custom-button
          :loading="isCsvDownloader"
          :disabled="isCsvButtonDisabled"
          tooltipText="一覧をCSVファイル形式でダウンロードします"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg"
          @click="onCsvButtonClick">
          CSVで出力
          <template v-slot:loader>
            <span>出力中...</span>
          </template>
        </dd-custom-button>
      </v-col>
      <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12" class="px-1">
        <v-row no-gutters justify="end">
          <div v-if="isShowCreateButton">
            <dd-custom-button
              :rounded="true"
              :minWidth="200"
              @click="onCreateButtonClick"
            >
              {{ functionName }}を新規追加する
            </dd-custom-button>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-1">
      <v-col :cols="6" class="hidden-md-and-down" />
      <v-col :xs="12" :sm="12" :md="6" :lg="6" :xl="6" :cols="12" class="px-1">
        <dd-select-items-per-page
          ref="pagination2"
          :itemsPerPage.sync="vitemsPerPage"
          :currentPage.sync="vPage"
          :items="items"
          @changeItemsPerPage="changeItemsPerPage"
          @changePage="changePage"
        />
      </v-col>
    </v-row>
  </div>
</div>
</template>

<script>
import DdCustomButton from '@/components/DdCustomButton'
import listMixin from '@/mixins/listMixins'
import { mapGetters } from 'vuex'

const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')

export default {
  name: 'DdListResult',
  mixins: [listMixin],
  props: {
    /**
     * データテーブル用ヘッダ
     */
    itemHeaders: Array,
    /**
     * データテーブル用データ
     */
    items: Array,
    /**
     * データテーブルキー
     */
    itemKey: String,
    /**
     * 機能名
     */
    functionName: String,
    /**
     * 追加ボタン表示
     */
    isShowCreateButton: {
      type: Boolean,
      default: true
    },
    /**
     * ページ
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * 1ページ当たりの行数
     */
    itemsPerPage: {
      type: Number,
      default: 100
    },
    /**
     * 検索結果件数
     */
    rowNumber: Number,
    /**
     * 選択状態
     */
    selected: Array,
    /**
     * 一括操作ボタン表示有無
     */
    isBatchCommand: {
      type: Boolean,
      default: true
    },
    /**
     * チェックボックス表示時有無
     */
    isShowSelect: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DdCustomButton,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage
  },
  data: () => ({
    // 一覧制御用
    isCsvDownloader: false,
    isPdfDownloader: false,
    // ページネーション用
    vitemsPerPage: 0,
    vPage: 1
  }),
  computed: {
    ...mapGetters({
      helpUseFlg: 'users/helpUseFlg'
    }),
    isCsvButtonDisabled () {
      return this.items.length === 0
    }
  },
  created () {
    this.vitemsPerPage = this.itemsPerPage
    this.vPage = this.page
  },
  mounted () {
  },
  methods: {
    onRowDoubleClick: function (e, f) {
      console.log('onRowDoubleClick', e, f)
      this.$emit('dblclick', e, f)
    },
    onRowEditButtonClick: function (e) {
      console.log('onRowEditButtonClick', e)
      this.$emit('edit', e)
    },
    onCreateButtonClick: function () {
      this.$emit('create')
    },
    onClearButtonClick: function () {
      this.$emit('clear')
    },
    onCsvButtonClick: function () {
      this.$emit('csvdl')
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.vitemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    changePage: function (e) {
      this.vPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.vitemsPerPage, this.vPage)
        this.$refs.pagination2.syncPagination(this.vitemsPerPage, this.vPage)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
</script>
